export default __webpack_public_path__ + "static/media/exteriorFinalizat3_2019.9a68edf6.jpeg";